// react-native-biometrics stand-in. Biometrics are hidden on web (decision
// D5: passkeys come after beta). The sensor reports unavailable, so every
// biometric branch in the app falls back to the password path it already has.

export const BiometryTypes = {
  TouchID: 'TouchID',
  FaceID: 'FaceID',
  Biometrics: 'Biometrics',
} as const;

export default class ReactNativeBiometrics {
  constructor(_options?: { allowDeviceCredentials?: boolean }) {}

  async isSensorAvailable(): Promise<{ available: boolean; biometryType?: string; error?: string }> {
    return { available: false, error: 'Biometrics are not available in a browser' };
  }
  async simplePrompt(_options: { promptMessage: string }): Promise<{ success: boolean; error?: string }> {
    return { success: false, error: 'Biometrics are not available in a browser' };
  }
  async biometricKeysExist(): Promise<{ keysExist: boolean }> {
    return { keysExist: false };
  }
  async createKeys(): Promise<{ publicKey: string }> {
    throw new Error('Biometrics are not available in a browser');
  }
  async deleteKeys(): Promise<{ keysDeleted: boolean }> {
    return { keysDeleted: false };
  }
  async createSignature(): Promise<{ success: boolean; signature?: string }> {
    return { success: false };
  }
}
